<template>
    <div class="modal fade" id="updateOrderStatusModal" tabindex="-1" aria-labelledby="updateOrderStatusModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <Form :validation-schema="schema" v-slot="{ handleSubmit, errors }" as="div">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <template v-if="action === 'approved_quotation'">Approve Quotation</template>
                            <template v-else>Update Order Status</template>
                        </h5>
                        <!-- <button type="button" class="btn-close" @click="hideModal"></button> -->
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            <label for="reasonInput" class="form-label">Enter Reason</label>
                            <Field 
                                name="comment" 
                                as="textarea" 
                                rows="3"
                                class="form-control" 
                                id="reasonInput" 
                                placeholder="Enter reason"
                                :class="{ 'is-invalid': errors.comment }"
                                v-model="orderData.comment"
                            />
                            <div v-if="errors.comment" class="is-invalid invalid-feedback">{{ errors.comment }}</div>
                        </div>
                        <p class="text-info">Are you sure you want to update the order status?</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-outline-danger" @click="hideModal">Cancel</button>
                        <button 
                            type="button" 
                            class="btn btn-sm btn-theme"
                            :disabled="processing"
                            :class="{'disabled': processing}"
                            v-text="processing ? 'Processing...' : 'Confirm'"
                            @click="handleSubmit($event, updateOrder)"
                        ></button>
                    </div>
                </Form>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "UpdateOrderStatus",
    props: {
        order: {
            type: Object,
            required: true
        },
        action: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            processing: false,
            orderData: {
                id: this.order.id,
                status: "pending",
                comment: ''
            }
        };
    },
    computed: {
        schema() {
            return {
                comment: 'required'
            };
        }
    },
    methods: {
        updateOrder() {
            this.processing = true;
            axios
                .post('/api/admin/orders/update-status', {
                    order_id: this.order.id,
                    status: "pending",
                    comment: this.orderData.comment,
                    action: "move_to_pending"
                })
                .then(response => {
                    // Hide the modal
                    this.hideModal();
                    
                    // Show success notification
                    this.$notification(response.data.status, response.data.message);

                    // Emit event to parent component
                    this.$emit('order-updated');
                })
                .catch(error => {
                    this.$notification("error", error.response.data.message);
                })
                .finally(() => {
                    this.processing = false;
                });
        },
        showModal() {
            $('#updateOrderStatusModal').modal('show');
        },
        hideModal() {
            $('#updateOrderStatusModal').modal('hide');

            this.$emitter.emit('reset-selected-order');
        },
        handleSubmit() {
            let self = this;

            // Prepare comment
            let comment = self.orderData.comment || '';
            if (comment.trim() === '') {
                self.$notification('error', 'Comment is required');
                return;
            }

            if (comment.length > 0) {
                comment += " - ";
            }

            if (self.action === 'quotation_approved') {
                comment += 'Quotation Approved, and order moved to Pending state.';
            }

            let postData = {
                order_id: self.order.id,
                status: "pending",
                comment: comment,
                action: "move_to_pending"
            };

            this.processing = true;
            axios.post("/admin/orders/update-status", postData)
                .then((response) => {
                    self.$notification(response.data.status,response.data.message);

                    // Hide modal
                    self.hideModal();

                    // Emit event to parent component
                    self.$emitter.emit('order-updated', {order: self.order});
                })
                .catch(error => {
                    this.$notification("error", error.response.data.message);
                })
                .finally(() => {
                    this.processing = false;
                });
        }
    }
}
</script>